// Configuración global de la app.
// El negocio activo viene de la sesión (services/negocioActual.js).

export const STOCK_BAJO = 2;

// Cloudflare Turnstile (anti-robots en login/registro). La SITE KEY es pública
// (va en el navegador); la SECRET KEY vive solo en Supabase (Auth → CAPTCHA).
// Vacía = Turnstile apagado.
export const TURNSTILE_SITE_KEY = process.env.REACT_APP_TURNSTILE_SITE_KEY || '0x4AAAAAAFO4lTjyrENzV9aC';

// Links de catálogo antiguos no traen ?n=<negocio>; asumen Lolita's Store.
export const NEGOCIO_CATALOGO_PREDETERMINADO = '23145265-459f-4ece-adcd-ef757a929c42';

// Categorías de gasto sugeridas (cap. 6.14). Comunes a cualquier negocio;
// el usuario puede escribir una libre. Migrable a tabla si se necesita.
// Lista por defecto (solo se usa como respaldo; las categorías reales viven
// en la tabla categorias_gasto, administrable por negocio).
export const CATEGORIAS_GASTO = [
  'Salarios', 'Transporte o logística o domicilios', 'Alquiler / renta', 'Servicios públicos',
  'Publicidad Meta Ads', 'Publicidad en televisión', 'Compra de productos o insumos',
  'Gastos administrativos', 'Mantenimiento y reparación', 'Muebles / equipo', 'Empaques',
  'Comisiones a empleados', 'Comisiones bancarias', 'Impuestos',
  'Alimentación o atención a clientes', 'Otros',
];

// Métodos de pago (cap. 5.11). Configurables por negocio en el futuro.
export const METODOS_PAGO = ['Efectivo', 'Tarjeta', 'Transferencia', 'Pago móvil', 'Crédito'];
